export enum DatasetState {
  None = 0,
  DatasetsLoading = 1 << 0,
  UpdateLoading = 1 << 1,
  DataLoading = 1 << 2,
  DatasetCreating = 1 << 3,
  Initialized = 1 << 4,
}
